import * as jquery from "jquery";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import Data from "source/app/services/Data";
import { LocalStorageKey } from "source/app/services/Shared/LocalStorageKey";
import type { QuickJournalThemeSelectionName } from "source/app/presentation/BottomBar/QuickJournal/View/QuickJournalTheme";
import Maths from "../../Maths";
import { desktopBackgroundImages } from "./DesktopImage/DesktopImage";
// const jquery = require('cash-dom');

class Background {
    public isAnimated: LocalStorageKey = new LocalStorageKey(
        "isAnimated",
        "false"
    );

    public ToggleAnimation = () => {
        if (IsMobileDevice()) {
            return;
        }

        const newValue = this.isAnimated.Toggle();
        newValue.Decide(this.StartAnimated, this.StopAnimated);
    };

    public SetAnimation = (newValue: boolean) => {
        if (IsMobileDevice()) {
            return false;
        }

        if (this.isAnimated.Get().value === String(newValue)) {
            return;
        }

        this.isAnimated.Set(String(newValue));
        this.isAnimated.Decide(this.StartAnimated, this.StopAnimated);
    };

    public Toggle = () =>
        this.isAnimated.Decide(this.StartAnimated, this.ChangeImage);

    private GetNewCSS = (newImagePath: string) => {
        const currBkgCSS = jquery("html").css("background-image");

        if (currBkgCSS === "") {
            throw new Error("Cannot extract background CSS string");
        }

        const newBkgCSS = currBkgCSS.replace(
            /http.*images\/.*\/.*"\)/,
            newImagePath
        );

        return newBkgCSS;
    };

    private SetCSS = (css: string) => {
        if (!css) throw new Error("Missing input CSS!");
        jquery("html").css("background", css);
        jquery("html").css("background-size", "cover");
        jquery("html").css("background-attachment", "fixed");
    };

    private StartAnimated = () => {
        Data.LoadFromServer("files/backgrounds/animated")
            .then((filenames: string[]) => {
                const randomGifIndex =
                    Maths.GetSingleRandomNumber(filenames.length) - 1;
                return filenames[randomGifIndex];
            })
            .then((filename: string) => {
                const newBackgroundCSS = this.GetNewCSS(filename + '")');
                this.SetCSS(newBackgroundCSS);
                this.isAnimated.Set("true");
            });
    };

    private StopAnimated = () => {
        this.isAnimated.Set("false");
        this.Toggle();
    };

    public ChangeImage = (themeName?: QuickJournalThemeSelectionName) => {
        if (IsMobileDevice()) {
            desktopBackgroundImages
                .GetRandomFullSizeBackground(themeName)
                .Show();
        } else {
            this.StartAnimated();
        }
    };
}

export default new Background();
